import React from 'react'
import AssetDetailsContainer from '../containers/AssetDetailsContainer'

const AssetDetailsPage = () => ( 
  <>    
    <div id="main-container" className="container mt-5">
      <AssetDetailsContainer /> 
    </div>
  </>
)

export default AssetDetailsPage